import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import Pagination from 'components/molecules/pagination';
import { useDispatch, useSelector } from 'react-redux';
import withLoaderTable from 'components/organisms/withLoader/withLoaderTable';
import ClinicRunBookLogItem from 'components/molecules/clinicRunBookLogItem';

const ClinicRunBookLogs = ({ clinicGuid }) => {
  const loading = useSelector(
    (state) => state.loading.effects.clinicRunBookLogs.getRunBookLogs,
  );
  const clinicRunBookLogs = useSelector((state) => state.clinicRunBookLogs);
  const {
    clinicRunBookLogs: { setPageHistories, getRunBookLogs, toggleOrder },
  } = useDispatch();

  useEffect(async () => {
    if (clinicGuid) await getRunBookLogs({ guidValue: clinicGuid });
  }, [clinicGuid]);

  const setPage = (pageOffset) => {
    setPageHistories({ pageOffset });
    getRunBookLogs({ guidValue: clinicGuid });
  };

  const toggleReversed = () => {
    toggleOrder();
    getRunBookLogs({ guidValue: clinicGuid });
  };

  return (
    <div className="date-note-logs">
      <Table borderless border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th colSpan="3">
              <Pagination
                renderOrder
                reversedOnChange={toggleReversed}
                reversed={clinicRunBookLogs.reverse}
                title="Clinic Instructions"
                page={clinicRunBookLogs.page}
                total={clinicRunBookLogs.totalCount}
                itemsPerPage={clinicRunBookLogs.items}
                pageTotal={clinicRunBookLogs.data.length}
                handlePrevClick={() => setPage(-1)}
                handleNextClick={() => setPage(+1)}
                handleFirstClick={() => setPage(-(clinicRunBookLogs.page - 1))}
                handleLastClick={() =>
                  setPage(
                    Math.ceil(
                      clinicRunBookLogs.totalPages / clinicRunBookLogs.pageStep,
                    ) - clinicRunBookLogs.page,
                  )
                }
                loading={loading}
              />
            </th>
          </tr>
        </thead>
        {withLoaderTable(
          loading,
          <tbody>
            {clinicRunBookLogs.data.map((clinicRunBookLog, index) => (
              <tr key={index}>
                <td />
                <td className="col-12 date-note-logs__log not-fixed">
                  <ClinicRunBookLogItem clinicRunBookLog={clinicRunBookLog} />
                </td>
              </tr>
            ))}
          </tbody>,
        )}
      </Table>
    </div>
  );
};

ClinicRunBookLogs.propTypes = {
  clinicGuid: PropTypes.string,
};
export default ClinicRunBookLogs;
